import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface PreEntitlementTransaction {
  id: string;
  [key: string]: any;
}

export interface PreEntitlementQueryParams {
  yield_ids?: string[];
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryPreEntitlementApi = createApi({
  reducerPath: "registrypreentitlement",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryPreEntitlement"],
  endpoints: (build) => ({
    getRegistryPreEntitlementDetails: build.query<PreEntitlementTransaction[], PreEntitlementQueryParams>({
      query: (params) => {
        return {
          url: "rs/registry/pre-entitlement/transaction",
          params: params,
          method: "GET",
        };
      },
      providesTags: ["RegistryPreEntitlement"],
    }),
  }),
});

export const {
  useGetRegistryPreEntitlementDetailsQuery,
} = registryPreEntitlementApi;
